// /pricing's text that the server puts in the HTML before #root (lib/seo-basics.js, TEAMBRIDGE_SEO_BASICS). It hides
// the app (#tb-initial-pricing ~ #root) until the Pricing page's cards are there; removing it shows the app in the
// same frame. Returns how far the text was scrolled; null if it's not there.
const ID = 'tb-initial-pricing';
export function takeInitialPricing(win = typeof window === 'undefined' ? null : window) {
  const text = win?.document?.getElementById(ID);
  if (!text) return null;
  const scrollY = win.scrollY || 0;
  text.remove();
  return {
    scrollY
  };
}
export const dropInitialPricing = takeInitialPricing;

// The cards are rendered (PlanRow): the page takes over at the place the text was scrolled to (the page scrolls
// in its own container, the text in the window).
export function handOverInitialPricing(node, win = typeof window === 'undefined' ? null : window) {
  const taken = takeInitialPricing(win);
  if (!taken?.scrollY || !node) return taken;
  for (let el = node.parentElement; el; el = el.parentElement) {
    if (/(auto|scroll)/.test(win.getComputedStyle(el).overflowY)) {
      el.scrollTop = taken.scrollY;
      break;
    }
  }
  return taken;
}